export const checkoutSteps = {
    _previousStep: 1,
    step: 1,
    _onStep: undefined,
    isLoadingStep: false,
    dirtySteps: {
        1: true,
        2: false,
        3: false,
        4: false,
    },
    checkoutStepsInit($watch, onStep) {
        $watch('step', (newValue) => {
            onStep(newValue, this._previousStep).then(() => {
                this.isLoadingStep = false;
            });
            this.dirtySteps[newValue] = true;
            this._previousStep = newValue;
        });
    },
    nextStep() {
        this.isLoadingStep = true;
        this.step++;
    },
    selectStep(selectedStep) {
        // Only allow moving to the next step if it has been dirtied/confirmed!
        if (selectedStep < 0 || selectedStep > Object.keys(this.dirtySteps).length) {
            return;
        }
        if (!this.dirtySteps[selectedStep]) {
            return;
        }
        this.isLoadingStep = true;
        this.step = selectedStep;
    },
};
